// Deutsch ist die QUELLE: hier steht der Text zuerst, und aus dieser Datei
// leitet sich der Typ des Katalogs ab (`Katalog`). Die englische Fassung
// (../en) ist deshalb nicht bloß eine zweite Sammlung, sondern muss diesen Typ
// erfüllen — ein fehlender oder überzähliger Key dort ist ein tsc-Fehler.
//
// Ein neuer Namespace wird an GENAU zwei Stellen eingehängt: hier und in
// ../en/index.ts. Alles andere (die Namespace-Dateien selbst) gehört jeweils
// einem Bereichs-Worker allein — deshalb sind es einzelne Dateien und kein
// gemeinsamer Katalog-Block.
import { blog } from "./blog";
import { calendar } from "./calendar";
import { common } from "./common";
import { datasets } from "./datasets";
import { documents } from "./documents";
import { labels } from "./labels";
import { mail } from "./mail";
import { nav } from "./nav";
import { notes } from "./notes";
import { overview } from "./overview";
import { projects } from "./projects";
import { questionnaires } from "./questionnaires";
import { settings } from "./settings";
import { shared } from "./shared";
import { tasks } from "./tasks";

export const de = {
  common,
  nav,
  settings,
  shared,
  labels,
  mail,
  tasks,
  notes,
  documents,
  datasets,
  projects,
  overview,
  calendar,
  questionnaires,
  blog,
};

/** Die Form JEDES Katalogs. Abgeleitet — nie von Hand gepflegt. */
export type Katalog = typeof de;
